// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1996":"f15bf3ef674c51b1","2187":"4027b59d466917f2","5473":"fa279da6cc990b24","7260":"6d55cb3ed05457ef","9003":"0d93f43f5af5f61e"}[chunkId] + ".css";
};